import { getCurrWorkspaceAlias } from '@/utils/workspace';

import { defaultAxios } from '..';

const attachmentService = {
  async uploadFeedbackAttachment(file: File) {
    const formData = new FormData();
    formData.append('file', file);
    const res = await defaultAxios.post(`/attachments/upload`, formData);
    return res.data;
  },
  async uploadEditorImage(file: File) {
    const formData = new FormData();
    formData.append('file', file);
    const res = await defaultAxios.post(`/attachments/editor`, formData);
    return res.data;
  },

  async getAttachment(alias: string, category: string) {
    const wAlias = getCurrWorkspaceAlias();
    const res = await defaultAxios.get(
      `workspaces/${wAlias}/attachments/${alias}?category=${category}`,
      {
        responseType: 'blob',
      },
    );
    return res.data;
  },
};

export default attachmentService;
